import { computed, ref } from 'vue'
import {
  progressClass as submitProgressClass,
  type ProgressState,
} from '../../models/current-student-advanced-standing-form/appSession'

export { submitProgressClass }
export type SubmitProgressState = ProgressState

export function isSubmitButtonDisabled(sending: boolean, agreementChecked: boolean): boolean {
  return sending || !agreementChecked
}

export function useSubmitApplicationState() {
  const agreementChecked = ref(false)
  const sending = ref(false)
  const buttonText = ref('Submit Application')
  const errorMessage = ref('')
  const progressVisible = ref(false)
  const progressMessage = ref('..')
  const progressState = ref<SubmitProgressState>('active')
  const applicationComplete = ref(false)
  const submittedReferenceCode = ref('')

  const progressClass = computed(() => submitProgressClass(progressState.value))
  const buttonDisabled = computed(() => isSubmitButtonDisabled(sending.value, agreementChecked.value))

  function startSubmit(): void {
    buttonText.value = 'Sending...'
    sending.value = true
    errorMessage.value = ''
    progressMessage.value = 'Submitting...'
    progressVisible.value = true
    progressState.value = 'active'
  }

  function completeSubmit(referenceCode: string): void {
    progressState.value = 'success'
    progressMessage.value = 'Success'
    buttonText.value = 'Done'
    submittedReferenceCode.value = referenceCode
    applicationComplete.value = true
  }

  function failSubmit(message: string): void {
    buttonText.value = 'Try Again'
    errorMessage.value = message
    progressState.value = 'error'
    progressMessage.value = 'Error'
    sending.value = false
  }

  return {
    agreementChecked,
    sending,
    buttonText,
    errorMessage,
    progressVisible,
    progressMessage,
    progressState,
    applicationComplete,
    submittedReferenceCode,
    progressClass,
    buttonDisabled,
    startSubmit,
    completeSubmit,
    failSubmit,
  }
}
